import { routeGuard } from "../../../router/guard";

export default [
  {
    path: "/notasfiscais",
    name: "NotasFiscais",
    beforeEnter: routeGuard,
    component: () => import("../views/Notas.vue"),
  },
];